/**
 * LAUBE — Ajoute deux comportements après un ajout au panier réussi :
 *  1) Anime le bouton « Ajouter au panier » avec ✓ + « Produit ajouté »
 *  2) Force la mise à jour du compteur du panier (cart-icon-bubble) en
 *     tapant /cart.js — failsafe si le replace de section échoue.
 *
 * S'appuie sur l'événement PUB_SUB_EVENTS.cartUpdate publié par product-form.js.
 */
(function () {
  function init() {
    if (typeof PUB_SUB_EVENTS === 'undefined' || typeof subscribe !== 'function') {
      // pubsub.js / constants.js pas encore chargés : on retente
      setTimeout(init, 100);
      return;
    }

    subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
      if (!data || data.source !== 'product-form') return;

      animateSubmitButton();
      refreshCartIconBubble();
    });
  }

  function animateSubmitButton() {
    var submitButton = document.querySelector('.laube-product-page .product-form__submit');
    if (!submitButton) return;

    var label = submitButton.querySelector('.laube-product__submit-label');
    if (!label) return;

    if (!submitButton.dataset.laubeOriginalLabel) {
      submitButton.dataset.laubeOriginalLabel = label.innerHTML;
    }

    label.innerHTML =
      '<span class="svg-wrapper" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24" focusable="false" aria-hidden="true">' +
      '<path d="M5 12l5 5L20 7" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>' +
      '</svg>' +
      '</span>' +
      'Produit ajouté';

    submitButton.classList.add('product-form__submit--added');

    if (submitButton.laubeRestoreTimeout) {
      clearTimeout(submitButton.laubeRestoreTimeout);
    }

    submitButton.laubeRestoreTimeout = setTimeout(function () {
      label.innerHTML = submitButton.dataset.laubeOriginalLabel;
      submitButton.classList.remove('product-form__submit--added');
    }, 2200);
  }

  function refreshCartIconBubble() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var cartLink = document.getElementById('cart-icon-bubble');
        if (!cartLink) return;

        var existingBubble = cartLink.querySelector('.cart-count-bubble');
        var count = cart.item_count;

        if (count > 0) {
          if (existingBubble) {
            var span = existingBubble.querySelector('span[aria-hidden="true"]');
            if (span) {
              span.textContent = count < 100 ? count : '';
            }
          } else {
            var bubble = document.createElement('div');
            bubble.className = 'cart-count-bubble';
            var visibleSpan = document.createElement('span');
            visibleSpan.setAttribute('aria-hidden', 'true');
            visibleSpan.textContent = count < 100 ? count : '';
            bubble.appendChild(visibleSpan);
            cartLink.appendChild(bubble);
          }
        } else if (existingBubble) {
          existingBubble.remove();
        }
      })
      .catch(function () {
        // silencieux : si /cart.js échoue, on laisse le flux Dawn standard se charger de l'update.
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
